import classNames from 'classnames';
import { TTextField } from '../types/types.ts';
import { TEST_ID } from '../utils/constants.ts';

const Text = ({ label, textAlign, size, fontWeight }: TTextField) => (
  <p className={classNames('flex text-base font-[450]', textAlign, fontWeight, size)} data-testid={TEST_ID.TEXT}>
    {label}
  </p>
);

export default Text;
